import { useEffect, useState } from 'react';
import { FiClock } from 'react-icons/fi';

export default function WrapUpHoldBanner({ until, onEnd }: { until: number | null; onEnd: () => void }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!until) return undefined;
    const timer = setInterval(() => setNow(Date.now()), 500);
    return () => clearInterval(timer);
  }, [until]);

  const secondsLeft = until ? Math.max(0, Math.ceil((until - now) / 1000)) : 0;
  if (!secondsLeft) return null;
  const mm = String(Math.floor(secondsLeft / 60)).padStart(2, '0');
  const ss = String(secondsLeft % 60).padStart(2, '0');

  return (
    <div
      role="status"
      className="flex items-center gap-3 rounded-xl bg-amber-100 px-3 py-2 text-xs text-amber-800 ring-1 ring-inset ring-amber-200 dark:bg-amber-950/40 dark:text-amber-200 dark:ring-amber-900"
    >
      <FiClock className="h-4 w-4 flex-shrink-0" />
      <span className="min-w-0 flex-1">
        <span className="font-semibold">Wrap-up in progress</span>
        {' — '}disposition saved. No calls until it ends in <span className="font-semibold tabular-nums">{mm}:{ss}</span>.
      </span>
      <button
        type="button"
        onClick={onEnd}
        className="flex-shrink-0 rounded-lg bg-amber-600 px-2.5 py-1 font-semibold text-white hover:bg-amber-700"
      >
        End wrap-up now
      </button>
    </div>
  );
}
